export default __webpack_public_path__ + "static/media/flag-netherlands.b90eb25d.svg";